import axios, { AxiosResponse } from 'axios';

// DELETE
// Delete virtual fish goup.
// /ewosapi/v1/planandprognosis/site/{localSiteId}/fishgroup/{fishGroupId}
export const deleteVirtualFishGroup = async (localSiteId: string, fishGroupId: string): Promise<AxiosResponse> => {
  return await axios.delete<AxiosResponse>(`/ewosapi/v1/planandprognosis/site/${localSiteId}/fishgroup/${fishGroupId}`);
};
